/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * UserRolesApi - axios parameter creator
 * @export
 */
export const UserRolesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new user.
         * @param {CreateUserRoleDto} createUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerCreate: (createUserRoleDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createUserRoleDto' is not null or undefined
            assertParamExists('userRolesV2ControllerCreate', 'createUserRoleDto', createUserRoleDto);
            const localVarPath = `/v2/user-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Find all users.
         * @param {PermissionEnum} [permissionKey]
         * @param {string} [userId]
         * @param {string} [workspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerFindAll: (permissionKey, userId, workspaceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/user-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (permissionKey !== undefined) {
                localVarQueryParameter['permissionKey'] = permissionKey;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a userRole by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerRemove: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userRolesV2ControllerRemove', 'id', id);
            const localVarPath = `/v2/user-role/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a user.
         * @param {string} id
         * @param {UpdateUserRoleDto} updateUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerUpdate: (id, updateUserRoleDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userRolesV2ControllerUpdate', 'id', id);
            // verify required parameter 'updateUserRoleDto' is not null or undefined
            assertParamExists('userRolesV2ControllerUpdate', 'updateUserRoleDto', updateUserRoleDto);
            const localVarPath = `/v2/user-role/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UserRolesApi - functional programming interface
 * @export
 */
export const UserRolesApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserRolesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new user.
         * @param {CreateUserRoleDto} createUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerCreate(createUserRoleDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userRolesV2ControllerCreate(createUserRoleDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Find all users.
         * @param {PermissionEnum} [permissionKey]
         * @param {string} [userId]
         * @param {string} [workspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerFindAll(permissionKey, userId, workspaceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userRolesV2ControllerFindAll(permissionKey, userId, workspaceId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a userRole by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerRemove(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userRolesV2ControllerRemove(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a user.
         * @param {string} id
         * @param {UpdateUserRoleDto} updateUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerUpdate(id, updateUserRoleDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userRolesV2ControllerUpdate(id, updateUserRoleDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UserRolesApi - factory interface
 * @export
 */
export const UserRolesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserRolesApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new user.
         * @param {CreateUserRoleDto} createUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerCreate(createUserRoleDto, options) {
            return localVarFp
                .userRolesV2ControllerCreate(createUserRoleDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find all users.
         * @param {PermissionEnum} [permissionKey]
         * @param {string} [userId]
         * @param {string} [workspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerFindAll(permissionKey, userId, workspaceId, options) {
            return localVarFp
                .userRolesV2ControllerFindAll(permissionKey, userId, workspaceId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a userRole by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerRemove(id, options) {
            return localVarFp
                .userRolesV2ControllerRemove(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a user.
         * @param {string} id
         * @param {UpdateUserRoleDto} updateUserRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRolesV2ControllerUpdate(id, updateUserRoleDto, options) {
            return localVarFp
                .userRolesV2ControllerUpdate(id, updateUserRoleDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserRolesApi - object-oriented interface
 * @export
 * @class UserRolesApi
 * @extends {BaseAPI}
 */
export class UserRolesApi extends BaseAPI {
    /**
     *
     * @summary Create a new user.
     * @param {CreateUserRoleDto} createUserRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesV2ControllerCreate(createUserRoleDto, options) {
        return UserRolesApiFp(this.configuration)
            .userRolesV2ControllerCreate(createUserRoleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find all users.
     * @param {PermissionEnum} [permissionKey]
     * @param {string} [userId]
     * @param {string} [workspaceId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesV2ControllerFindAll(permissionKey, userId, workspaceId, options) {
        return UserRolesApiFp(this.configuration)
            .userRolesV2ControllerFindAll(permissionKey, userId, workspaceId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a userRole by id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesV2ControllerRemove(id, options) {
        return UserRolesApiFp(this.configuration)
            .userRolesV2ControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a user.
     * @param {string} id
     * @param {UpdateUserRoleDto} updateUserRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRolesApi
     */
    userRolesV2ControllerUpdate(id, updateUserRoleDto, options) {
        return UserRolesApiFp(this.configuration)
            .userRolesV2ControllerUpdate(id, updateUserRoleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
